<script lang="ts">
	export let content: string;
	export let accent: boolean = false;
	export let itemprop = '';
</script>

{#if accent}
	<p
		class="w-fit rounded bg-white px-4 py-1 text-red-600 drop-shadow-sm dark:bg-zinc-900 dark:text-white {$$props.class}"
		{itemprop}
	>
		{content}
	</p>
{:else}
	<p
		class="w-fit rounded bg-white px-4 py-1 text-neutral-900 drop-shadow-sm dark:bg-zinc-900 dark:text-white {$$props.class}"
	>
		{content}
	</p>
{/if}
